import { render, staticRenderFns } from "./Offlinepayment.vue?vue&type=template&id=2fe8faca&scoped=true&"
import script from "./Offlinepayment.vue?vue&type=script&lang=js&"
export * from "./Offlinepayment.vue?vue&type=script&lang=js&"
import style0 from "./Offlinepayment.vue?vue&type=style&index=0&id=2fe8faca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe8faca",
  null
  
)

export default component.exports